import { toAsciiFilenameSlug } from './transliterateRu'

const sanitizeFilenamePart = (value: string): string => toAsciiFilenameSlug(value)

const formatOrderBlankDate = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = String(date.getFullYear()).slice(-2)
  return `${day}${month}${year}`
}

export const buildOrderBlankFilename = (
  restaurantName: string,
  organizationId: number,
  /** Тот же бланк выгружается в разных форматах — расширение задаётся вызывающим. */
  extension: 'pdf' | 'xlsx' = 'pdf',
): string => {
  const now = new Date()
  const datePart = formatOrderBlankDate(now)
  const slug = sanitizeFilenamePart(restaurantName)
  const storageKey = `provisium.order-blank-seq:${organizationId}:${datePart}`
  const nextSequence = Number(localStorage.getItem(storageKey) ?? '0') + 1
  localStorage.setItem(storageKey, String(nextSequence))
  return `${slug}-order-blank-${datePart}-${nextSequence}.${extension}`
}
